import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Logo, Watermark } from "../components/brand/Logo";

export default function AuthPage({ mode = "sign-in" }) {
  return (
    <div className="flex min-h-screen bg-[#F7F5F0]" data-testid={`auth-page-${mode}`}>
      <aside className="relative hidden w-[44%] flex-col justify-between overflow-hidden bg-[#196ABC] p-12 lg:flex">
        <Watermark className="-bottom-40 -right-40" />
        <Link to="/" data-testid="auth-home-link"><Logo variant="vertical" tone="white" /></Link>
        <p className="relative font-serif text-3xl italic text-[#F7F5F0]/85">Clareza para decidir, agilidade para avançar.</p>
      </aside>
      <main className="flex flex-1 flex-col items-center justify-center gap-8 p-6">
        <Link to="/" className="lg:hidden" data-testid="auth-home-link-mobile"><Logo variant="horizontal" tone="blue" /></Link>
        {mode === "sign-in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </main>
    </div>
  );
}
